@if (password) {
    <div class="strength-container">
        <mat-progress-bar 
            [ngClass]="{
                'weak': strengthValue < 40,
                'medium': strengthValue >= 40 && strengthValue < 80,
                'strong': strengthValue >= 80
            }" 
            [value]="strengthValue" 
            mode="determinate">
        </mat-progress-bar>
        <div class="strength-label">{{ strengthLabel }}</div>
        <div class="must-have-label">Password must contain:</div>
        <ul class="requirements-list">
            @for (req of requirements; track $index) {
                <li [class.valid]="req.valid">
                    <mat-icon class="icon">
                        {{ req.valid ? 'check_circle' : 'cancel' }}
                    </mat-icon>
                    {{ req.label }}
                </li>
            }
        </ul>
    </div>
}